import { DataQueryKey, UseDataQueryKey } from '../../../hooks/useDataQuery/dataQuery.types';
import {
  GetProductColorSelloutMetricsParams,
  GetProductColorsSelloutTotalsParams,
} from './product-color-sellout.types';

export const getProductColorSelloutKey = (
  params: GetProductColorSelloutMetricsParams,
): UseDataQueryKey => [
  DataQueryKey.PRODUCT_COLOR_SELLOUT,
  params.productColorId,
  params.orderId ?? 'no-order',
];

export const getTotalProductColorSelloutKey = (
  params: GetProductColorsSelloutTotalsParams,
): UseDataQueryKey => [
  DataQueryKey.PRODUCT_TOTALS_COLOR_SELLOUT,
  params.orderId ?? 'no-order',
  params.productColorIds?.slice().sort(),
];
